import {createStore} from 'vuex'

import config from "./modules/config";
import status from "./modules/status";
import setSearchData from "./modules/setSearchData";

let store = createStore({
	modules: {
		config,
		status,
		setSearchData
	}
});

export default store;